import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isCurrentLanguageRtl } from 'modules/language/selectors/language';
import { UploadField } from '@navjobs/upload';
import { Tooltip as Hint } from '@material-ui/core';

import { Icon } from 'shared/components';
import isBase64Image from 'modules/user/utils/isBase64Image';

import theme from './UserIconWithEdit.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  avatar: PropTypes.string,
  handleAvatarUpload: PropTypes.func,
  removeAvatar: PropTypes.func,
};

const defaultProps = {
  avatar: null,
  handleAvatarUpload: () => null,
  removeAvatar: () => null,
};

const UserIconWithEdit = ({ children, avatar, handleAvatarUpload, removeAvatar }) => {
  const [isRemovePending, setRemovePending] = useState(false);
  const handleRemoveAvatar = () => {
    setRemovePending(true);
    removeAvatar().finally(() => setRemovePending(false));
  };

  return isBase64Image(avatar) && !isRemovePending ? (
    <div className={ theme.root }>
      <div className={ theme.iconContainer }>
        <Hint
          placement={ isCurrentLanguageRtl() ? 'left' : 'right' }
          title={
            <FormattedMessage
              id="MyAccount.Remove.Avatar.Toolti"
              defaultMessage="** Remove photo"
            />
          }
        >
          <div className={ theme.hintContainer } onClick={ handleRemoveAvatar }>
            <Icon name="trash" className={ theme.icon } />
          </div>
        </Hint>
      </div>

      <div className={ theme.avatar }>{ children }</div>
    </div>
  ) : (
    <UploadField
      onFiles={ handleAvatarUpload }
      onChange={ e => e.target.value = '' }
      uploadProps={{ accept: '.jpg,.jpeg,.png' }}
    >
      { children }
    </UploadField>
  );
};

UserIconWithEdit.propTypes = propTypes;
UserIconWithEdit.defaultProps = defaultProps;

export default UserIconWithEdit;
